//ASA-1202389266570028 | Removed this.iframe.setAttribute('src', this.sanitizedUrl); as changing src adds to the history of browser thus hijacking back button.
export const updateIframeUrl = (iframe: HTMLIFrameElement, iframeUrl?: string): void => {
  if (iframe?.contentWindow)
    iframe.contentWindow.location.replace(iframeUrl);
}
